import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import token_red from './images/token-red.png';
import token_green from './images/token_nqtb.png';

const ModelsByCategory = ({
  modelsList,
  expandedModels,
  selectedModels,
  user,
  toggleExpand,
  handleAllCheckboxChange,
  handleCheckboxChange
}) => {
  const [expandedCategories, setExpandedCategories] = useState([]);

  const PREDEFINED_CATEGORIES = [
    "Human toxicity",
    "Environmental toxicity",
    "Physicochemical properties"
  ];

  const groupedModels = PREDEFINED_CATEGORIES.reduce((acc, cat) => {
    acc[cat] = modelsList.filter(
      model => (model.model_category || "").toLowerCase() === cat.toLowerCase()
    );
    return acc;
  }, {});

  const otherModels = modelsList.filter(
    model => !PREDEFINED_CATEGORIES.some(
      cat => cat.toLowerCase() === (model.model_category || "").toLowerCase()
    )
  );
  if (otherModels.length > 0) {
    groupedModels["Other"] = otherModels;
  }

  const isModelFullySelected = (model) => {
    const allCellLines = model.cell_line?.cell_line || [];
    const selectedForModel = selectedModels[model.id] || [];
    return allCellLines.length > 0 && allCellLines.every(cl => selectedForModel.includes(cl));
  };

  const isCategoryAllSelected = (models) => {
    if (models.length === 0) return false;
    return models.every(model => isModelFullySelected(model));
  };

  const isGlobalAllSelected = () => {
    if (modelsList.length === 0) return false;
    return modelsList.every(model => isModelFullySelected(model));
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev =>
      prev.includes(category) ? prev.filter(c => c !== category) : [...prev, category]
    );
  };

  const handleGlobalAllClick = (isChecked) => {
    modelsList.forEach(model => {
      const allCellLines = model.cell_line?.cell_line || [];
      handleAllCheckboxChange(model.id, allCellLines, isChecked);
    });
  };

  const handleCategoryAllClick = (categoryModels, isChecked) => {
    categoryModels.forEach(model => {
      const allCellLines = model.cell_line?.cell_line || [];
      handleAllCheckboxChange(model.id, allCellLines, isChecked);
    });
  };

  return (
    <>
      <div className="global-select-section" style={{ padding: '10px', marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #eee' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={isGlobalAllSelected()}
            onChange={(e) => handleGlobalAllClick(e.target.checked)}
          />
          <strong style={{ fontSize: '15px' }}>Select all categories</strong>
        </label>
      </div>

      {Object.entries(groupedModels).map(([category, models]) => {
        const isExpanded = expandedCategories.includes(category);
        const hasModels = models.length > 0;
        const allSelected = isCategoryAllSelected(models);

        return (
          <div key={category} className="model-category-section" style={{ marginBottom: '15px' }}>
            <div
              className="category-header"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '10px',
                background: '#f8f9fa',
                borderRadius: '8px'
              }}
            >
              <div onClick={() => toggleCategory(category)} style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon
                  icon={isExpanded ? faChevronUp : faChevronDown}
                  style={{ marginRight: '12px', color: '#667085' }}
                />
                <h3 className='hum-tox-p' style={{ margin: 0, fontSize: '1.1rem' }}>{category}</h3>
              </div>

              {hasModels && (
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px' }} onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) => handleCategoryAllClick(models, e.target.checked)}
                  />
                  <strong>Select All</strong>
                </label>
              )}
            </div>

            {isExpanded && (
              <div className='up-sel-mod' style={{ padding: '10px 0 10px 25px' }}>
                {!hasModels ? (
                  <p style={{ color: '#999', fontStyle: 'italic', padding: '10px' }}>
                    No endpoints available for this category.
                  </p>
                ) : (
                  models.map((model) => {
                    const allCellLines = Array.isArray(model.cell_line?.cell_line) ? model.cell_line.cell_line : [];
                    const modelFullySelected = isModelFullySelected(model);

                    return (
                      <div key={model.id} className="model-row">
                        <div className="model-header" onClick={() => toggleExpand(model.id)}>
                          <span className="chevron-btn">
                            <FontAwesomeIcon icon={expandedModels.includes(model.id) ? faChevronUp : faChevronDown} />
                          </span>
                          <p className="mdl-name">{model.model_name}</p>
                        </div>

                        {expandedModels.includes(model.id) && (
                          <div className="cell-line-list">
                            {/* Wyświetlamy sekcję 'All' tylko jeśli mamy więcej niż jedną linię */}
                            {allCellLines.length > 1 && (
                              <div className="cell-line-row">
                                <label className="cell-line-item">
                                  <input
                                    className="inputs-cell-lines"
                                    type="checkbox"
                                    checked={modelFullySelected}
                                    onChange={() => handleAllCheckboxChange(model.id, allCellLines)}
                                  />
                                  <span className="cell-line-label">All</span>
                                </label>
                              </div>
                            )}

                            {/* Lista konkretnych linii komórkowych */}
                            {allCellLines.map((cl, idx) => (
                              <div key={idx} className="cell-line-row">
                                <label className="cell-line-item">
                                  <input
                                    className="inputs-cell-lines"
                                    type="checkbox"
                                    checked={selectedModels[model.id]?.includes(cl) || false}
                                    onChange={() => handleCheckboxChange(model.id, cl)}
                                  />
                                  <span className="cell-line-label">{cl}</span>
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default ModelsByCategory;
